import React from 'react'
import Editor from '../../../../../../components/Editor'
import { useMutation } from 'react-query'
import toast from 'react-hot-toast'
import { errorResponse } from '../../../../../../components/utils/errorResponse'
import { cohorts } from '../../../../../../api/cohort'

const CohortInvitationEmail = ({ setCurrentStep, content, setContent, cohortId}: any) => {

  const orgId = JSON.parse(sessionStorage.getItem('user')!)?.org?.id
  const addInvitationMutation: any = useMutation(cohorts.addCohortInvitationEmail, {
    onSuccess: () => {
        toast.remove()
        toast.success('Cohort Invitation Email Added Successfully!')
        setCurrentStep(4)
    },
    onError: error => errorResponse(error),
    onMutate: () => {
        toast.loading('Loading...')
    }
  })

  const addInvitationEmail = () => {
    if(!content) toast.error('Error! Add Invitation Template')
    else addInvitationMutation.mutate({
      cohortId, orgId, payload: {
        messageText: content
      }
   })
  }

  return (
    <>
       <div className={`w-[86%] mt-5 mx-auto shadow-2xl p-4 rounded-lg h-[auto] bg-white `}>
              <header className='flex justify-between items-center'>
                   <div>
                      <h1 className='text-md font-semibold mt-1'>
                        Cohort Invitation Email
                      </h1>
                      <p className='text-xs mb-2 text-gray-700'>
                        Emails to recieve when learners have been enrolled on a cohort.
                      </p>
                   </div>
              </header>
             <div className='border-t border-gray-300'>
                  <Editor 
                    content={content}
                    setContent={setContent}
                  />
                  <div className='flex mt-5 justify-end'>
                      <button
                        className={'w-[200px] text-center btn bg-primary-blue'} 
                        onClick={  addInvitationEmail }
                      > 
                        Add Cohort Invitation Email
                      </button>  
                  </div>    
             </div>
         </div>
    </>
  )
}

export default CohortInvitationEmail